import React from 'react';
import numeral from 'numeral';

import ItemsSummary from './ItemsSummary';

const CartSummary = ({
  shoppingCartItems,
  totals,
  review
}) => {

  const {
    freight,
    subTotal,
    tax,
    totalAmountDue,
    totalMarkdown
  } = totals || {};

  return (
    <div className="cart-summary">
      <div className="summary-top">

        <ItemsSummary
          review={review}
          items={shoppingCartItems || []}
        />

        <div className="row">
          <div className="col">
            <h3>Summary</h3>
          </div>
          <div className="col d-sm-block d-lg-none">
            <h3 className="text-right" aria-label="toggle cart">
              <a
                href="#"
                className="expand-mobile-cart"
                aria-label="toggle cart"
              >
                <i
                  className="fas fa-chevron-down this-closed"
                />
                <i className="fas fa-times this-open" />
              </a>
            </h3>
          </div>
        </div>
        <table width="100%" className="summary">
          <tbody>
            <tr>
              <td>Subtotal:</td>
              <td className="text-right">
                {numeral(subTotal).format('$0,0.00')} USD
              </td>
            </tr>
            <tr>
              <td>Estimated Shipping:</td>
              <td className="text-right">
                {numeral(freight).format('$0,0.00')} USD
              </td>
            </tr>
            <tr>
              <td>Estimated Tax:</td>
              <td className="text-right">
                {numeral(tax).format('$0,0.00')} USD
              </td>
            </tr>
            {!!totalMarkdown && (
              <tr style={{ color: '#900' }}>
                <td>Discount:</td>
                <td className="text-right">
                  -{numeral(totalMarkdown).format('$0,0.00')} USD
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="summary-bottom">
        <table width="100%" className="total">
          <tbody>
            <tr>
              <td>TOTAL:</td>
              <td className="text-right">
                {numeral(totalAmountDue).format('$0,0.00')} USD
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CartSummary